<template>
    <div class="country-container">
        <div class="Destination--Banner">
            <img src="https://resource.rcclchina.com.cn/Banner/%E4%B8%9C%E4%BA%AC-1920-500.jpg" alt="目的地及岸上观光">
        </div>
        <div class="Destination--Container">
            <div class="Destination--Country">
                <ul class="country">
                    <li
                        v-for="item in countryList"
                        :key="item.id"
                        v-bind:class="{countryActive: activeId === item.id}"
                        @click="handleTab(item.id)"
                    >{{item.countryCNName}}</li>
                </ul>
            </div>
            <div class="country-list">
                <div
                    v-for="(item, index) in countryList"
                    :key="item.id"
                    :class="`country-item country-${index}`"
                >
                    <div class="countryList">
                        <div class="Japan--Place">
                            <div class="Japan--Img">
                                <div class="name-country">{{item.countryCNName}}</div>
                                <div v-if="getBanners(item).length>1" style="height: 100%;">
                                    <div class="carousel slide" v-for="(banner, i) in getBanners(item)" :key="(item.id+'_'+i)">
                                        <div class="carousel-inner">
                                            <div class="item" :class="{active: i == 0}">
                                                <img :src="banner" :alt="item.countryCNName">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else-if="getBanners(item).length == 1" style="height: 100%;">
                                    <div class="carousel slide">
                                        <div class="carousel-inner">
                                            <div class="item active">
                                                <img :src="getBanners(item)[0]" :alt="item.countryCNName">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="Japan--Map">
                                <img :src="item.mapImageUrl" :alt="item.countryCNName">
                                <div v-for="(cityItem, cityIndex) in countryMap[index].cities" :key="cityIndex" :style="cityItem.pos" v-bind:class="{cur: `${item.id}_${cityIndex}` === curId}" @mouseover="handleOver(item, cityIndex)" @mouseleave="handleLeave">
                                    <div class="city-Japan">
                                        <router-link target="_blank" :to="`/Rccl.CustomPage/ShorexIntro/ShorexIntroList?cityName=${encodeURIComponent(cityItem.city)}`">{{cityItem.city}}</router-link>
                                    </div>
                                    <div class="img-content">
                                        <router-link :to="`/Rccl.CustomPage/ShorexIntro/ShorexIntroList?cityName=${cityItem.city}`" target="_blank">
                                            <img src="https://resource.rcclchina.com.cn/Destination/image/icon.png">
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="cityList">
                        <div class="Japan--MajorCities">
                            <div class="Major--Cities">主要城市</div>
                            <div class="MajorCities--Name">
                                <ul>
                                    <li
                                        v-for="(cityItem, cityIndex) in countryMap[index].cities"
                                        :key="cityIndex"
                                        v-bind:class="{nameActive: `${item.id}_${cityIndex}` === curId}"
                                        @mouseover="handleOver(item, cityIndex)"
                                        @mouseleave="handleLeave"
                                    >
                                        <router-link target="_blank" :to="`/Rccl.CustomPage/ShorexIntro/ShorexIntroList?cityName=${cityItem.city}`">{{cityItem.city}}</router-link>
                                    </li>
                                </ul>
                                <div class="both"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import api from '@/api'
    import { delayDev } from '@/utilities/tools'

    export default {
        name: 'CountryList',
        components: {},
        data () {
            return {
                countryList: [],
                countryMap: [],
                activeId: '',
                curId: '',
                countryPos: [],
            }
        },
        beforeMount () {
            this.initPage()
        },
        methods: {
            async initPage () {
                const data = await this.getCountryList()

                this.countryList = data.filter(item => item.cityPartRecords !== null)

                this.countryMap = this.getPos()
                this.activeId = this.countryList[0].id

                delayDev(200, () => {
                    this.countryPos = this.getItemPos(this.countryList)
                })
            },
            getBanners (item) {
                return item.banners || []
            },
            handleTab (id) {
                this.activeId = id
                const item = this.countryPos.find(target => target.id === id)
                window.scroll({
                    top: item.offsetTop,
                    behavior: 'smooth'
                })
            },
            handleOver (item, index) {
                this.curId = item.id + '_' + index
            },
            handleLeave () {
                this.curId = ''
            },
            async getCountryList () {
                this.$loading.show()
                const {success, data, errMsg} = await api.page.getCountryList()
                this.$loading.hide()
                if (!success) {
                    console.log(errMsg)
                    return null
                } else {
                    return data
                }
            },
            getPos () {
                const pos = []
                if (!this.countryList || this.countryList.length == 0) return pos
                this.countryList.forEach((item) => {
                    let country = {
                        country: item.countryCNName,
                        cities: []
                    }
                    if (item.cityPartRecords && item.cityPartRecords.length > 0) {
                        item.cityPartRecords.forEach((city) => {
                            if (city.topDis>0 || city.leftDis>0) {
                                country.cities.push({
                                    city: city.cityCNName,
                                    pos: `top: ${city.topDis}%; left: ${city.leftDis}%;`
                                })
                            } else {
                                country.cities.push({
                                    city: city.cityCNName,
                                    pos: `top: ${city.topDis}%; left: ${city.leftDis}%; display: none;`
                                })
                            }
                            
                        })
                    }
                    pos.push(country)
                })

                return pos
                // return [
                //     {
                //         country: '日本',
                //         cities: [
                //             {
                //                 city: '长崎',
                //                 pos: 'top: 67.00%; left: 9.00%'
                //             },
                //             {
                //                 city: '福冈',
                //                 pos: 'top: 61.00%; left: 15.00%'
                //             },
                //             {
                //                 city: '熊本',
                //                 pos: 'top: 70.00%; left: 16.00%'
                //             },
                //             {
                //                 city: '冲绳',
                //                 pos: 'top: 92.00%; left: 15.00%'
                //             },
                //             {
                //                 city: '鹿儿岛',
                //                 pos: 'top: 83.00%; left: 12.00%'
                //             },
                //             {
                //                 city: '神户',
                //                 pos: 'top: 43.00%; left: 49.00%'
                //             },
                //             {
                //                 city: '下关港',
                //                 pos: 'top: 56.00%; left: 16.00%'
                //             },
                //             {
                //                 city: '京都',
                //                 pos: 'top: 39.00%; left: 46.00%'
                //             },
                //             {
                //                 city: '大阪',
                //                 pos: 'top: 48.00%; left: 56.00%'
                //             },
                //             {
                //                 city: '东京',
                //                 pos: 'top: 32.00%; left: 85.00%'
                //             },
                //             {
                //                 city: '高知',
                //                 pos: 'top: 60.00%; left: 38.00%'
                //             },
                //             {
                //                 city: '名古屋',
                //                 pos: 'top: 40.00%; left: 62.00%'
                //             },
                //             {
                //                 city: '境港',
                //                 pos: 'top: 45.00%; left: 39.00%'
                //             },
                //             {
                //                 city: '佐世保',
                //                 pos: 'top: 63.00%; left: 8.00%'
                //             },
                //             {
                //                 city: '函馆',
                //                 pos: 'top: .00%; left: 80.00%'
                //             },
                //             {
                //                 city: '新潟',
                //                 pos: 'top: 15.00%; left: 77.00%'
                //             },
                //             {
                //                 city: '富士山(清水)',
                //                 pos: 'top: 43.00%; left: 70.00%'
                //             }
                //         ]
                //     },
                //     {
                //         country: '菲律宾',
                //         cities: [
                //             {
                //                 city: '马尼拉',
                //                 pos: 'top: 29.00%; left: 43.00%'
                //             },
                //             {
                //                 city: '长滩',
                //                 pos: 'top: 47.00%; left: 47.00%'
                //             },
                //             {
                //                 city: '苏比克',
                //                 pos: 'top: 25.00%; left: 37.00%'
                //             }
                //         ]
                //     },
                //     {
                //         country: '越南',
                //         cities: [
                //             {
                //                 city: '岘港(真美港)',
                //                 pos: 'top: 43.00%; left: 62.00%'
                //             },
                //             {
                //                 city: '胡志明',
                //                 pos: 'top: 76.00%; left: 55.00%'
                //             },
                //             {
                //                 city: '芽庄',
                //                 pos: 'top: 66.00%; left: 68.00%'
                //             }
                //         ]
                //     },
                //     {
                //         country: '俄罗斯',
                //         cities: [
                //             {
                //                 city: '海参崴',
                //                 pos: 'top: 45.00%; left: 89.00%'
                //             }
                //         ]
                //     },
                //     {
                //         country: '新加坡',
                //         cities: []
                //     }
                // ]
            
            },
            getItemPos (data) {
                const result = []
                data.map((item, index) => {
                    const offsetTop = document.querySelector(`.country-${index}`).offsetTop
                    result.push({
                        country: item.countryCNName,
                        id: item.id,
                        offsetTop: offsetTop
                    })
                })
                return result
            },
        }
    }
</script>

<style lang="less" scoped>
    .country-container{
        padding-bottom: 30px;
        background-color: #f0f0f0;
    }
    .Destination--Banner img{
        width:100%;
    }
    .Destination--Container{
        background: #f0f0f0;
        margin-top:-40px;
    }
    .Destination--Container .Destination--Country{
        width:1138px;
        height:92px;
        background: #fff;
        margin: 0 auto;
        position: relative;
        top:-2px;
        border-radius: 5px;
    }
    .Destination--Country .country{
        width: 1002px;
        height: 92px;
        margin: 0 auto;
    }
    .Destination--Country .country li{
        width: 143px;
        height: 92px;
        float: left;
        text-align: center;
        line-height: 92px;
        cursor: pointer;
        font-weight: 500;
    }
    .destinationPosition{
        width: 100% !important;
        position: fixed !important;
        top:0 !important;
        z-index: 10;
        box-shadow: 0 0 8px rgba(0,0,0,.4);
    }
    .Japan--Place{
        width: 1138px;
        height:462px;
        margin: 0 auto;
        overflow: hidden;
    }
    .Destination--Container .countryList{
        margin-top:20px;
    }
    .Japan--Place .Japan--Img,.Japan--Place .Japan--Map{
        float: left;
    }
    .Japan--Place .Japan--Map img{
        height: 100%;
    }
    .Japan--Place .Japan--Img{
        width: 661px;
        height:462px;
        position: relative;
    }
    .Japan--Place .carousel,
    .Japan--Place .carousel-inner,
    .Japan--Place .carousel-inner .item{
        height: 100%;
    }
    .Japan--Place .carousel-inner .item{
        position: relative;
    }
    .Japan--Place .Japan--Img img{
        display: block;
        position: absolute;
        right: 0;
        top: 0;
        max-width: none;
        height: 100%;
    }
    .Japan--Img .control-right,.Japan--Img .control-left{
        line-height: 462px;
        cursor: pointer;
    }
    .Japan--Img .name-country{
        width: 100%;
        color: #fff;
        position: absolute;
        bottom: 39px;
        font-size: 32px;
        text-align: center;
        z-index: 1;
    }
    .Japan--Place .Japan--Map{
        width: 477px;
        height: 462px;
        position: relative;
    }
    .Japan--MajorCities{
        width: 1138px;
        height: auto;
        margin: 0 auto;
        background: #fff;
        padding-bottom: 28px;
        overflow: hidden;
    }
    .Japan--MajorCities .Major--Cities{
        width: 1103px;
        height: 58px;
        margin: 0 auto;
        border-bottom: 1px solid #e5e5e5;
        text-align: center;
        line-height: 58px;
        color: #333333;
        font-size: 15px;
        font-weight: 500;
    }
    .countryList .Japan--Map .img-content{
        position: relative;
    }
    .countryList .Japan--Map>div{
        width: 20px;
        height: 11px;
        border-radius: 9px;
        position: absolute;
        cursor: pointer;
        &.cur{
            .img-content {
                display: block;
            }
        }
    }
    .countryList .Japan--Map>div .city-Japan{
        width: 70px;
        position: absolute;
        top:-2px;
        left:-23px;
        text-align: center;
    }
    .countryList .Japan--Map>div .city-Japan a{
        font-weight: 600;
        font-size: 14px;
        color: #031257;
    }
    .countryList .Japan--Map>div .city-Japan a:hover{
        text-decoration:none;
    }
    .countryList .Japan--Map .img-content {
        display: none;
    }
    .countryList .Japan--Map .img-content img{
        position: absolute;
        width: 30px;
        height: auto;
        top: -34px;
        left: -4px;
        z-index:2;
    }
    .countryList .Japan--Map .city0{
        top: 187px;
        left: 222px;
    }
    .countryList .Japan--Map .city1{
        top: 199px;
        left: 235px;
    }
    .countryList .Japan--Map .city2{
        top: 205px;
        left: 189px;
    }
    .countryList .Japan--Map .city3{
        top: 235px;
        left: 146px;
    }
    .countryList .Japan--Map .city4{
        top: 260px;
        left: 94px;
    }
    .countryList .Japan--Map .city5{
        top: 285px;
        left: 81px;
    }
    .countryList .Japan--Map .city6{
        top: 294px;
        left: 43px;
    }
    .countryList .Japan--Map .city7{
        top: 314px;
        left: 51px;
    }
    .countryList .Japan--Map .city8{
        top: 327px;
        left: 81px;
    }
    .countryList .Japan--Map .city9{
        top: 384px;
        left: 67px;
    }
    .countryList .Japan--Map .city10{
        top: 369px;
        left: 97px;
    }
    .countryList .Japan--Map .city11{
        top: 439px;
        left: 73px;
    }
    .countryList .Japan--Map .city12{
        top: 274px;
        left: 183px;
    }
    .countryList .Japan--Map .city13{
        top: 195px;
        left: 363px;
    }
    .countryList .Japan--Map .city14{
        top: 149px;
        left: 409px;
    }
    .countryList .Japan--Map .city15{
        top: 183px;
        left: 305px;
    }
    .countryList .Japan--Map .Caribbean{
        top: 226px;
        left: 274px;
    }
    .Japan--MajorCities .MajorCities--Name{
        width: 1138px;
        height: auto;
        margin: 0 auto;
        padding: 0 20px;
    }
    .Japan--MajorCities .MajorCities--Name ul{
        width: 100%;
    }
    .Japan--MajorCities .MajorCities--Name li{
        width: 99px;
        height: 56px;
        float: left;
        border-right: 1px dotted #dbdbdb;
        text-align: center;
        line-height: 56px;
        margin-top: 20px;
    }
    .Japan--MajorCities .MajorCities--Name li a{
        color: #031257;
        font-size: 14px;
        font-weight:  600;
        display:inline-block;
        width:100%;
    }
    .MajorCities--Name .Visit--Route{
        margin-top: -40px;
        color: #666666;
        font-size: 14px;
        font-weight: 500;
    }
    .MajorCities--Name .Visit--Route .Number{
        color: #006ab7;
        font-weight: 600;
        margin-right: 3px;
    }
    .Taiwan--Place{
        margin-top: 20px;
    }
    .country--container{
        width: 100%;
        position: relative;
        top:-20px;
    }
    .nameBorder{
        border-right: none !important;
    }
    .nameActive{
        background: #fbc300;
        border-radius: 5px;
        cursor: pointer;
    }
    .nameActive a{
        color: #000 !important;
    }
    .fontActive{
        color: #fff !important;
        font-size: 14px;
        font-weight: 600;
    }
    .countryActive{
        border-bottom: 3px solid #0e6bb3;
        color: #0e6bb3;
        cursor: pointer;
        -webkit-transition: border-bottom .0s,color .5s;
    }
</style>
